module.exports = __webpack_public_path__ + "static/media/bookshop.4ce1f571.svg";